/* This is generated code, don't alter */
var limit_condition;
(function (limit_condition) {
    limit_condition[limit_condition["MAXIMUM_MATERIAL_CONDITION"] = 0] = "MAXIMUM_MATERIAL_CONDITION";
    limit_condition[limit_condition["LEAST_MATERIAL_CONDITION"] = 1] = "LEAST_MATERIAL_CONDITION";
    limit_condition[limit_condition["REGARDLESS_OF_FEATURE_SIZE"] = 2] = "REGARDLESS_OF_FEATURE_SIZE";
})(limit_condition || (limit_condition = {}));
const limit_conditionCount = 3;
export { limit_condition, limit_conditionCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMaplimit_condition = new Int32Array([2]);
let prefixSumAddresslimit_condition = new Uint32Array([0, 28, 56, 82]);
let slotMaplimit_condition = new Int32Array([0, 2, 1]);
let encodedDatalimit_condition = (new TextEncoder()).encode(".MAXIMUM_MATERIAL_CONDITION..REGARDLESS_OF_FEATURE_SIZE..LEAST_MATERIAL_CONDITION.");
let limit_conditionSearch = new MinimalPerfectHash(gMaplimit_condition, prefixSumAddresslimit_condition, slotMaplimit_condition, encodedDatalimit_condition);
export { limit_conditionSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function limit_conditionDeserializeStep(input, cursor, endCursor) {
    return parser.extract(limit_conditionSearch, input, cursor, endCursor);
}
